import { TIMESTAMP, PT_BR } from '@/utils/dateFormats';
import { formatDate } from '@/utils/tableColumns';

export default {
  totalProcesses: [],
  totalProcessesByStatus: [],
  totalProcessesSeries: [],
  processes: [],
  processPages: {
    from: 0,
    to: 0,
    current_page: 1,
    next_page: 0,
    prev_page: 0,
    per_page: 10,
    last_page: 1,
    total: 0,
  },
  processosFiltrar: [],
  processosArquivos: [],
  selectedProcess: {},
  // Processo selecionado
  objectSelected: {},
  lisProcess: { lis: [] },
  columnsToExport: [],
  filtros: {
    perPage: 20,
    page: 1,
    campoData: [],
    periodo: [],
    termo: '',
    encerrado: false,
    referenciaCliente: '',
    referenciaInterna: '',
    codigoStatusEmbarque: [],
    cliente: '',
    unidadeNegocio: '',
    unidadeMedida: '',
    quantidade: '',
    dataAbertura: '',
    exportador: '',
    transportador: '',
    produto: '',
    ncms: '',
    etd: '',
    etdCondicao: '',
    eta: '',
    etaCondicao: '',
    dataEmbarque: '',
    dataEmbarqueCondicao: '',
    dataChegada: '',
    dataChegadaCondicao: '',
    conhecimentoEmbarque: '',
    dataRecebimentoOriginais: '',
    dataRecebimentoOriginaisCondicao: '',
    numeroRegistroDI: '',
    dataRegistroDI: '',
    dataRegistroDICondicao: '',
    canalRegistroDI: '',
    dataDesembaracoDI: '',
    dataDesembaracoDICondicao: '',
    dataFechamento: '',
    dataFechamentoCondicao: '',
    numeroNotaEntrada: '',
    containers: '',
    emissaoNotaEntrada: '',
    emissaoNotaEntradaCondicao: '',
    dataFechamentoOperacional: '',
    dataFechamentoOperacionalCondicao: '',
    dataExecucaoCarregamento: '',
    dataExecucaoCarregamentoCondicao: '',
    descricaoLicencaImportacao: '',
    nomeArmador: '',
    statusLI: '',
    incotermValores: '',
    navio: '',
    order: '',
    direcao: 'ASC',
  },
  campos: {
    codigoStatusEmbarque: 'codigoStatusEmbarque',
    referenciaCliente: 'referenciaCliente',
    referenciaInterna: 'referenciaInterna',
    cliente: 'cliente',
    unidadeNegocio: 'unidadeNegocio',
    unidadeMedida: 'unidadeMedida',
    quantidade: 'quantidade',
    dataAbertura: 'dataAbertura',
    exportador: 'exportador',
    transportador: 'transportador',
    produto: 'produto',
    ncms: 'ncms',
    etd: 'etd',
    eta: 'eta',
    dataEmbarque: 'dataEmbarque',
    dataChegada: 'dataChegada',
    conhecimentoEmbarque: 'conhecimentoEmbarque',
    dataRecebimentoOriginais: 'dataRecebimentoOriginais',
    numeroRegistroDI: 'numeroRegistroDI',
    dataRegistroDI: 'dataRegistroDI',
    canalRegistroDI: 'canalRegistroDI',
    dataDesembaracoDI: 'dataDesembaracoDI',
    dataFechamento: 'dataFechamento',
    numeroNotaEntrada: 'numeroNotaEntrada',
    containers: 'containers',
    emissaoNotaEntrada: 'emissaoNotaEntrada',
    dataFechamentoOperacional: 'dataFechamentoOperacional',
    dataExecucaoCarregamento: 'dataExecucaoCarregamento',
    descricaoLicencaImportacao: 'descricaoLicencaImportacao',
    nomeArmador: 'nomeArmador',
    statusLI: 'statusLI',
    navio: 'navio',
    incotermValores: 'incotermValores',
    valorTotalProcesso: 'valorTotalProcesso',
    nomeFabricante: 'nomeFabricante',
    sigleMoedaInvoice: 'siglaMoedaInvoice',
  },
  colDefault: 'referenciaCliente',
  directionDefault: 'ASC',
  colunasDisponiveis: [
    {
      fixed: true,
      hidden: false,
      label: 'Status do Embarque',
      field: 'codigoStatusEmbarque',
      type: 'text',
      filter: 'SetFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
        filterSet: [
          'PRÉ-EMBARQUE',
          'EM TRÂNSITO',
          'DESEMBARAÇO',
          'CARREGAMENTO',
          'FECHAMENTO',
        ],
      },
    },
    {
      fixed: true,
      hidden: false,
      label: 'Referência Cliente',
      field: 'referenciaCliente',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      fixed: true,
      hidden: false,
      label: 'Referência Trust',
      field: 'referenciaInterna',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: false,
      label: 'Navio',
      field: 'navio',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: false,
      label: 'Cliente',
      field: 'cliente',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: false,
      label: 'Un. de Negócio',
      field: 'unidadeNegocio',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Un. de Medida',
      field: 'unidadeMedida',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: false,
      label: 'Quantidade',
      field: 'quantidade',
      type: 'text',
      filter: 'NumberFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Abertura',
      field: 'dataAbertura',
      type: 'date',
      dateInputFormat: TIMESTAMP,
      dateOutputFormat: PT_BR,
      formatFn: formatDate,
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: false,
      label: 'Exportador',
      field: 'exportador',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Transportadora',
      field: 'transportador',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: false,
      label: 'Produto',
      field: 'produto',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: false,
      label: 'Valor Total Invoice',
      field: 'valorTotalProcesso',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: false,
      label: 'Fabricante',
      field: 'nomeFabricante',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'NCM',
      field: 'ncms',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: false,
      label: 'ETD',
      field: 'etd',
      type: 'date',
      dateInputFormat: TIMESTAMP,
      dateOutputFormat: PT_BR,
      formatFn: formatDate,
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: false,
      label: 'ETA',
      field: 'eta',
      type: 'date',
      dateInputFormat: TIMESTAMP,
      dateOutputFormat: PT_BR,
      formatFn: formatDate,
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Embarque',
      field: 'dataEmbarque',
      type: 'date',
      dateInputFormat: TIMESTAMP,
      dateOutputFormat: PT_BR,
      formatFn: formatDate,
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Chegada',
      field: 'dataChegada',
      type: 'date',
      dateInputFormat: TIMESTAMP,
      dateOutputFormat: PT_BR,
      formatFn: formatDate,
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: false,
      label: 'Conhecimento de Embarque',
      field: 'conhecimentoEmbarque',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Originais',
      field: 'dataRecebimentoOriginais',
      type: 'date',
      dateInputFormat: TIMESTAMP,
      dateOutputFormat: PT_BR,
      formatFn: formatDate,
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: false,
      label: 'Número DI',
      field: 'numeroRegistroDI',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: false,
      label: 'Registro DI',
      field: 'dataRegistroDI',
      type: 'date',
      dateInputFormat: TIMESTAMP,
      dateOutputFormat: PT_BR,
      formatFn: formatDate,
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Canal DI',
      field: 'canalRegistroDI',
      type: 'text',
      filter: 'SetFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
        filterSet: [
          'VERDE',
          'AMARELO',
          'VERMELHO',
          'CINZA',
        ],
      },
    },
    {
      hidden: true,
      label: 'Desembaraço',
      field: 'dataDesembaracoDI',
      type: 'date',
      dateInputFormat: TIMESTAMP,
      dateOutputFormat: PT_BR,
      formatFn: formatDate,
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Faturamento',
      field: 'dataFechamento',
      type: 'date',
      dateInputFormat: TIMESTAMP,
      dateOutputFormat: PT_BR,
      formatFn: formatDate,
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Nº NF Entrada',
      field: 'numeroNotaEntrada',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Containers',
      field: 'containers',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Emissão NF Entrada',
      field: 'emissaoNotaEntrada',
      type: 'date',
      dateInputFormat: TIMESTAMP,
      dateOutputFormat: PT_BR,
      formatFn: formatDate,
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Fechamento Operacional',
      field: 'dataFechamentoOperacional',
      type: 'date',
      dateInputFormat: TIMESTAMP,
      dateOutputFormat: PT_BR,
      formatFn: formatDate,
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Exec. Carregamento',
      field: 'dataExecucaoCarregamento',
      type: 'date',
      dateInputFormat: TIMESTAMP,
      dateOutputFormat: PT_BR,
      formatFn: formatDate,
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Licenças de Importação',
      field: 'descricaoLicencaImportacao',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Status L.I',
      field: 'statusLI',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'incoterms',
      field: 'incotermValores',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Armador/Agente de carga',
      field: 'nomeArmador',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Free Time',
      field: 'freeTime',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Porto Destino',
      field: 'portoDestino',
      type: 'text',
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Mapa',
      field: 'mapa',
      type: 'text',
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Presença de Carga',
      field: 'presencaCarga',
      type: 'text',
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
    {
      hidden: true,
      label: 'Siscarga',
      field: 'siscarga',
      type: 'text',
      filter: 'DateFilter',
      filterParams: {
        module: 'Processes',
        fetch: 'fetchProcessosPaginados',
      },
    },
  ],
  filtroMapaStatus: '',
  emTempoAtrasados: {
    data: [0, 0, 0], // atrasados, adiantados, emTempo
    processos: [],
    atrasados: 0,
    adiantados: 0,
    emTempo: 0,
    totalProcessos: 0,
    colors: [
      '#FD5353',
      '#34D0B4',
      '#3CF3BC',
    ],
    colorFechados: [
      '#FEBABA',
      '#99E4E5',
      '#8AF8D7',
    ],
  },
  dateCols: [
    'etd',
    'eta',
    'dataRegistroDI',
    'dataExecucaoCarregamento',
    'dataAbertura',
    'dataChegada',
    'dataRecebimentoOriginais',
    'dataEmbarque',
    'dataDesembaracoDI',
    'emissaoNotaEntrada',
    'dataFechamentoOperacional',
    'dataFaturamento',
    'dataExecucaoCarregamento',
    'carregamentoAgendado',
    '',
  ],
  renderCols: [
    'containers',
    'transportador',
    'canalRegistroDI',
    'conhecimentoEmbarque',
    'numeroRegistroDI',
    'faturamento',
    'numeroRegistroDI',
    'unidadeMedida',
    'quantidade',
    'numeroNotaEntrada',
    'descricaoLicencaImportacao',
    'statusLI',
    'nomeArmador',
    'cliente',
  ],
  documentosProcessoSelecionado: [],
  resetKanbanFilters: false,
};
